import '../../css/LoginPage.css';

const InputField = ({ type, placeholder, value, onChange, required }) => {
  return (
    <div className="input-container">
      <input
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        className="input-field"
        required={required}
      />
    </div>
  );
};

export default InputField;